/**
 * The four statuses the context rail's drive-sync bar reports.
 * Derived from `useMatterExternalSyncStatus`: whether an account is connected, and whether this
 * matter has an active folder mapping.
 */
export enum ContextRailDriveSyncStatus {
  /** Connected account, active folder mapping for this matter. */
  Synced = 'synced',
  /** An account exists but is no longer usable — disconnected, errored, or needs reauth. */
  Disconnected = 'disconnected',
  /** No connected account at all. */
  NotConnected = 'not-connected',
  /** Connected account, but no folder mapped to this matter. */
  NoFolderSynced = 'no-folder-synced',
}
